export class NotificationPreference implements INotificationPreference {
    enabled:boolean = null;
    suspended?:Date = null; // Null indicates not suspended
    delay?:number = null; // In seconds
    throttle?:number = null;
    sendIfUserOnline:boolean = null;

    public constructor(init?:Partial<INotificationPreference>) {
        if (init?.delay === -1) {
            init.delay = null;
        }
        if (init) {
            for (let key in init) {
                if (this.hasOwnProperty(key)) {
                    this[key] = init[key];
                }
            }
        }
    }
}

export interface INotificationPreference {
    enabled:boolean;
    suspended?:Date; // Null indicates not suspended
    delay?:number; // In seconds
    throttle?: number; // In seconds, do not send more than one notification in this time period
                        // Applied on a per-user + per-site + (per-type + per-device for alerts) basis
    sendIfUserOnline?:boolean; // If true, send the notification even if the user is online
}